import { render, staticRenderFns } from "./EDM.vue?vue&type=template&id=7383ff4e&scoped=true&"
import script from "./EDM.vue?vue&type=script&lang=js&"
export * from "./EDM.vue?vue&type=script&lang=js&"
import style0 from "./EDM.vue?vue&type=style&index=0&id=7383ff4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383ff4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
